import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { url } from "../../Constant";
import { useAuth } from "../../Context/AuthProvider";
import ReactPaginate from "react-paginate";
import { checkIndividualPermission } from "../../Utils/PermissionFunctions";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Callinitialize = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [incomingData, setIncomingData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [apicalled, setApiCalled] = useState(false);

  const { auth } = useAuth();
  useEffect(() => {
    getCampagin(1);
  }, []);
  useEffect(() => {
    if (apicalled === true) {
      getCampagin(1);
    }
  }, [apicalled]);
  const columns = [
    // {
    //   name: "Campaign ID",
    //   selector: (row) => row.campaign_id,
    //   // sortable: true,
    // },
    {
      name: "Campaign Name",
      selector: (row) => row.campaign_name,
      // sortable: true,
    },
    {
      name: "Campaign Type",
      selector: (row) => row.call_type,
      // sortable: true,
    },

    {
      name: "Campaign Start Time",
      selector: (row) =>
        row.camp_start_time === null
          ? "0000-00-00 00:00:00"
          : row.camp_start_time,
      // sortable: true,
    },
    {
      name: "Campaign End Time",
      selector: (row) =>
        row.camp_end_time === null ? `0000-00-00 00:00:00` : row.camp_end_time,
      // sortable: true,
    },
    {
      name: "Campaign Status",
      selector: (row) => row.runningStatus,
    },
    {
      name: "Limit",
      selector: (row) => row.call_limit,
    },

    {
      name: "Action",
      selector: (row) => row,
      // sortable: true,
      cell: (row) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            className={"btn-design-call  greenColor"}
            // style={{ marginLeft: "10px" }}
            onClick={() => statusUpdate(row)}
            disabled={row.runningStatus === "Completed" ? true : false}
          >
            {row.status === 0 ? "play" : "pause"}
          </button>
          <button
            className={"btn-design-call alertColor"}
            onClick={() => deleteCampagin(row)}
            disabled={row.runningStatus === "Completed" ? true : false}
          >
            Delete
          </button>
          <button
            className={"btn-design-call  greenColor"}
            // style={{ marginLeft: "10px" }}
            onClick={() =>
              // (window.location.href = `/campagin-upload/${row.campaign_id}`)
              navigate(`/campagin-upload/${row.campaign_id}`, { replace: true })
            }
          >
            upload
          </button>
        </div>
      ),
    },
    {
      name: "Prompt",
      selector: (row) => row.call_limit,
      cell: (row) => {
        const audioSrcWav = ("wav", row.prompt);
        const audioSrcMp3 = ("mp3", row.prompt);

        return (
          <audio
            className="mp3Audio"
            controls
            target="_blank"
            rel="noopener noreferrer"
            onContextMenu={(e) => e.preventDefault()}
          >
            <source src={audioSrcWav} type="audio/wav" />
            <source src={audioSrcMp3} type="audio/mp3" />
            Your browser does not support the audio tag.
          </audio>
        );
      },
    },
    {
      name: "",
      selector: (row) => row.callrecording,
      // sortable: true,
      cell: (row) => (
        <div>
          &nbsp;&nbsp;&nbsp;
          <Link
            to={`/campaign-number/${row.campaign_id}`}
            className="exportData-button"
          >
            View
          </Link>
        </div>
      ),
    },
  ];

  const getCampagin = (page) => {
    setLoader(true);
    axios
      .post(
        url + "view-campaign",
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          setLoader(false);
          if (
            response.data.message === "Data Not Found" &&
            response.data.data.length === 0
          ) {
            setIncomingData([]);
          } else if (response.data.message === "Data Found") {
            setIncomingData(response.data.data.get_campaign);
            setPageCount(response.data.data.pages);
          }
        },
        (error) => {
          console.log(error);
          setLoader(false);
        }
      );
  };

  const deleteCampagin = (row) => {
    axios
      .post(
        url + "delete-campaign",
        {
          campaign_id: row.campaign_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            setApiCalled(false);
            if (
              response.data.message === "Campaign Delete successfully" &&
              response.data.data.length === 0
            ) {
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
              setTimeout(() => {
                getCampagin();
              }, 1000);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const statusUpdate = (row) => {
    axios
      .post(
        url + "change-status",
        {
          campaign_id: row.campaign_id,
          status: row.status === 0 ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            setApiCalled(false);
            if (
              response.data.message === "Record Update successfully" &&
              response.data.data.length === 0
            ) {
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
              setTimeout(() => {
                getCampagin();
              }, 1000);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredIncomming = incomingData.filter((val) => {
    return (
      (val.call_type &&
        val.call_type.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.campaign_name &&
        val.campaign_name.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.campaign_id &&
        val.campaign_id.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handlePageChange = (data) => {
    // console.log(data);
    setLoader(true);
    getCampagin(data.selected + 1);
    setCurrentPage(data.selected + 1);
  };

  return (
    <>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  <h3>CALL INITIALIZE</h3>
                  {/* {auth.role === "2" && (
                    <p>
                      Use this page to view the call logs or call history,
                      including inbound, outbound, and missed calls.
                    </p>
                  )} */}
                </div>
              </div>
              {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}

              <div className="uk-width-1-1 ">
                <>
                  <div className="ImcomingCallMain CallInit">
                    {/* <div > */}
                    <div className="uk-grid" uk-grid="">
                      <div className="uk-width-1-2">
                        <div className="uk-text-left">
                          <div className="CustomSearch">
                            <form className="uk-search uk-search-default">
                              <input
                                className="uk-search-input"
                                type="text"
                                placeholder="Search by all field"
                                value={searchText}
                                onChange={handleSearch}
                              />
                            </form>
                          </div>
                        </div>
                      </div>

                      <div className="uk-width-1-2">
                        <div className="uk-text-right">
                          <span>
                            {(auth.role === "2" ||
                              (auth.role === "3" &&
                                checkIndividualPermission(
                                  "campaign",
                                  "read_and_write"
                                ))) && (
                              <div className="uk-inline uk-text-left">
                                <Link
                                  className="exportData-button NewFlow"
                                  to={
                                    auth.role === "3"
                                      ? "/upload-campaign"
                                      : "/upload-campaign"
                                  }
                                >
                                  Create campagin
                                </Link>
                              </div>
                            )}
                          </span>
                          {/* <span>
                            <div className="uk-inline uk-text-left">
                              <a
                                className="exportData-button"
                                // onClick={handleOpenFilterModal}
                                to="upload-campaign"
                              >
                                Upload Campaign
                              </a>
                            </div>
                          </span> */}
                        </div>
                      </div>
                    </div>

                    <div>
                      {/* {loader ? (
                        <div uk-spinner="" className="tableloader"></div>
                      ) : (
                        <DataTable
                          columns={columns}
                          data={filteredIncomming}
                          responsive="true"
                          // pagination
                        />
                      )} */}
                      {loader ? (
                        <div uk-spinner="" className="tableloader"></div>
                      ) : filteredIncomming.length === 0 ? (
                        <div className="customtableNoDataText">
                          There are no records to display
                        </div>
                      ) : (
                        <div className="customTableCallInitiate">
                          <table>
                            <thead>
                              <tr>
                                <th>Campaign Name</th>
                                <th>Campaign ID</th>
                                <th>Campaign Type</th>
                                <th>Campaign Start Time</th>
                                <th>Campaign End Time</th>
                                <th>Campaign Status</th>
                                <th>Limit</th>
                                <th>Action</th>
                                <th>Prompt</th>
                                <th>View</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredIncomming.map((val, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{val.campaign_name}</td>
                                    <td>{val.campaign_id}</td>
                                    <td>{val.call_type}</td>
                                    <td>
                                      {val.camp_start_time === null
                                        ? "0000-00-00 00:00:00"
                                        : val.camp_start_time}
                                    </td>
                                    <td>
                                      {val.camp_end_time === null
                                        ? `0000-00-00 00:00:00`
                                        : val.camp_end_time}
                                    </td>
                                    <td>{val.runningStatus}</td>
                                    <td>{val.call_limit}</td>
                                    <td>
                                      {" "}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <button
                                          className={
                                            "btn-design-call  greenColor"
                                          }
                                          // style={{ marginLeft: "10px" }}
                                          onClick={() => statusUpdate(val)}
                                          disabled={
                                            val.runningStatus === "Completed"
                                              ? true
                                              : false
                                          }
                                        >
                                          {val.status === 0 ? "play" : "pause"}
                                        </button>
                                        <button
                                          className={
                                            "btn-design-call alertColor"
                                          }
                                          onClick={() => deleteCampagin(val)}
                                          disabled={
                                            val.runningStatus === "Completed"
                                              ? true
                                              : false
                                          }
                                        >
                                          Delete
                                        </button>
                                        <button
                                          className={
                                            "btn-design-call  greenColor"
                                          }
                                          // style={{ marginLeft: "10px" }}
                                          onClick={() =>
                                            // (window.location.href = `/campagin-upload/${row.campaign_id}`)
                                            navigate(
                                              `/campagin-upload/${val.campaign_id}`,
                                              { replace: true }
                                            )
                                          }
                                        >
                                          upload
                                        </button>
                                      </div>
                                    </td>
                                    <td>
                                      <audio
                                        className="mp3Audio"
                                        controls
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onContextMenu={(e) =>
                                          e.preventDefault()
                                        }
                                      >
                                        <source src={val.prompt} />
                                        Your browser does not support the audio
                                        tag.
                                      </audio>
                                    </td>
                                    <td>
                                      {/* <div> */}
                                      <Link
                                        to={`/campaign-number/${val.campaign_id}`}
                                        className="exportData-button"
                                      >
                                        View
                                      </Link>
                                      {/* </div> */}
                                    </td>
                                  </tr>
                                  <br />
                                </>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <div className="tablePaginationBox ">
                        <div className="uk-margin-left"></div>
                        <div>
                          {" "}
                          {pageCount > 0 && (
                            <ReactPaginate
                              previousLabel={"<"}
                              nextLabel={">"}
                              breakLabel={"...."}
                              pageCount={pageCount}
                              onPageChange={handlePageChange}
                              containerClassName={
                                "uk-pagination uk-float-right contatPagination"
                              }
                              activeClassName={"uk-active"}
                              marginPagesDisplayed={3}
                              pageRangeDisplayed={6}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Callinitialize;
